<template>
  <div>
    <img :src="src" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: "app-logo",
  props: {
    src: {
      type: String,
      default: "/img/vaitty.svg",
    },
    alt: {
      type: String,
      default: "Vaitty",
    },
  },
};
</script>

<style>
img {
    width: 100%;
}
</style>